var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUpBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00018 6.61022C1.00339 6.51374 1.04648 6.42218 1.12035 6.35501L6.71623 1.10855C6.79046 1.03909 6.8911 1 6.99603 1C7.10095 1 7.20159 1.03909 7.27582 1.10855L12.8717 6.35501C12.9513 6.42349 12.9976 6.51948 12.9999 6.62064C13.0022 6.72188 12.9604 6.81968 12.884 6.89128C12.8076 6.96288 12.7033 7.00213 12.5954 6.99991C12.4874 6.99769 12.3851 6.95434 12.3121 6.8797L6.99603 1.89558L1.67994 6.8797C1.60536 6.95163 1.50293 6.99211 1.39595 6.99211C1.28896 6.99211 1.18655 6.95146 1.11195 6.87954C1.03745 6.80761 0.997126 6.71047 1.00016 6.61022L1.00018 6.61022Z",
    fill: "#008BD2",
    stroke: "#008BD2",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlue);
export default __webpack_public_path__ + "static/media/arrowUpBlue.48e97f7368c8c44f4032d725811b5d7b.svg";
export { ForwardRef as ReactComponent };